import React, {useState, useEffect} from 'react';
import {Select, Form} from 'antd';
import api from '../../../server/api'
import './index.scss';


const ProvinceSelect = props => {
    const [options, setOptions] = useState([]);
    useEffect(() => { // 获取消息类型
        api.proConfig({type: 'project,keyword'}).then(res => {
            const options = [];
            console.log(res)
            Object.keys(res.project.tender_type).forEach(index => {
                options.push({
                    label: res.project.tender_type[index],
                    value: index,
                })
            })
            setOptions(options);
        })
    },[props])
  
    return (
        <Form.Item
            label={props.label}
            name={props.name}
            rules={props.rules}
        >
            <Select
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                optionFilterProp="children"
                placeholder={props.placeholder}
                options={options} 
            />
        </Form.Item>
        
    )
}

export default ProvinceSelect;